import { SUPPORT_EMAIL } from "constants/contactInfo";
import { Fragment } from "react";

/**
 * CLE-3074 — a message from the API (or the page) with every occurrence of the support email turned
 * into a mailto link. Plain text otherwise; nothing else in the message is interpreted.
 */
export function SupportEmailText({ text }: { text: string }) {
  const parts = text.split(SUPPORT_EMAIL);
  return (
    <>
      {parts.map((part, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={index}>
          {part}
          {index < parts.length - 1 && (
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
          )}
        </Fragment>
      ))}
    </>
  );
}

/** One line per message, each with the support email linked. */
export function SupportEmailMessages({ messages }: { messages: string[] }) {
  return (
    <span className="flex flex-column gap-1">
      {messages.map((message, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <span key={index}>
          <SupportEmailText text={message} />
        </span>
      ))}
    </span>
  );
}
